import { helpers } from '../helpers.js';

var map = {
	selectors: { },

	init: function () {
		var self = this;

		jQuery( '.initmap__click' ).on( 'click', function( event ){
			event.preventDefault();
			
			const googleAPI = jQuery( this ).parent().parent().find( '.google-maps-api-src' );
			googleAPI.attr( 'src', googleAPI.attr( 'data-src' ) );

			// jQuery( this ).parent().addClass( 'initmap--shoud-load' );
			setTimeout(function(){
				self.initMap();
				jQuery( this ).parent().addClass( 'initmap--loaded' );
			}, 150 );
		});

	},

	initMap: function() {
		var self = this;

		document.querySelectorAll( '.initmap.initmap--shoud-load:not( .initmap--loaded )' ).forEach(function( map, item){
			let mapData = JSON.parse( map.getAttribute( 'data-mapdata' ) );
			const mapZoom = parseInt( map.getAttribute( 'data-zoom' ) );
			const colored = map.getAttribute( 'data-colored' );

			// console.log( mapData );

			let options = {
				zoom: ( mapZoom ) ? mapZoom : 16, // Default zoom, could be adjusted based on your needs
				center: {lat: mapData[0].lat, lng: mapData[0].lng }, // Center map based on first location or specific logic

				//disableDefaultUI: true,
				streetViewControl: false, // Disable Street View
				mapTypeControl: false, // Disable Map Type Control
				fullscreenControl: false, // Disable Fullscreen Control
				// zoomControl: true, // Disable Zoom Control
				rotateControl: false, // Disable Rotate Control
				scaleControl: false, // Disable Scale Control
			};

			let styleOptions = {
				styles: [
					{
						featureType: "poi", // Target all points of interest
						stylers: [{ visibility: "off" }] // Hide them
					},
					{
						featureType: "transit", // Target all forms of transit for a cleaner map
						stylers: [{ visibility: "off" }] // Hide them
					},
					{
						featureType: "road", // Enhance or simplify roads
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }] // Hide road labels/icons for a cleaner look
					},
					{
						featureType: 'road',
						elementType: 'geometry',
						stylers: [{ color: '#EFEFEF' }] // Set road color to white
					},
					{
						featureType: 'landscape',
						elementType: 'geometry',
						stylers: [{ color: '#FFFFFF' }] // Set the landscape color to black
					},
				]
			};

			if( colored == "false" ) {
				options = {
					...options,
					...styleOptions
				};
			}

			var map = new google.maps.Map( map, options );
		
			// Loop through locations to place markers
			mapData.forEach(function(location) {
				if( location.address == undefined) {
					location.address = (Math.random() + 1).toString(36).substring(7);
				}
				var marker = new google.maps.Marker({
					position: {lat: location.lat, lng: location.lng},
					map: map,
					title: location.address.trim(), // Optional: could be replaced with any other location data
					// icon: `${location.customIcon}#poid-${location.poid}`
					icon: {
						url: `${location.customIcon}#poid-${location.poid}`,
						size: new google.maps.Size(72, 82),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 41)
					}
				});

				marker.set( 'data-poid', location.poid );

				if( ! location.poid ) {
					return;
				}

				// document.querySelector( `[data-poid="${location.poid}"]` ).setAttribute( 'data-title', location.address );
				setTimeout(function(){
					document.querySelector( `img[src$="#poid-${location.poid}"]` ).setAttribute( 'data-title', location.address );
				}, 50 );

				google.maps.event.addListener( marker, 'click', function() {
					// self.openCard( marker[ 'data-poid' ] );

					//map.setCenter(marker.getPosition());

					var scale = Math.pow(2, map.getZoom());
					var nw = new google.maps.LatLng(
						map.getBounds().getNorthEast().lat(),
						map.getBounds().getSouthWest().lng()
					);
			
					var nwPoint = map.getProjection().fromLatLngToPoint(nw);
					var point = map.getProjection().fromLatLngToPoint(marker.getPosition());
					// Calculate the new point location with the desired offset
					var newPoint = new google.maps.Point(
						point.x, // x is unchanged because we only want to move it up
						point.y - (100 / scale) // Moving the map up by 50 pixels
					);
			
					// Convert the new point back to LatLng
					var newCenter = map.getProjection().fromPointToLatLng(newPoint);
			
					// Set the map's center to the new LatLng
					map.setCenter(newCenter);

				});
			});
		});
	},
};

export { map };